Details of the `HiringOrganization` that submitted the candidate profile.
